import { boolean, InferType, object, string } from "yup";

export type IFormularioPluggyIntegracaoSchema = InferType<
  typeof formPluggyIntegracaoSchema
>;

export const formPluggyIntegracaoSchema = object({
  Data: string().required(),
  Conta: string().required(),
  PluggyByRange: boolean().required(),
  DataInicio: string().nullable(),
  DataFim: string().nullable()
});
